import React from 'react';
import { ApolloProvider, Query } from 'react-apollo';
import gql from 'graphql-tag';
import CatastropheGenerator from '../components/Succession/CatastropheGenerator';
import ErrorBoundary from '../components/ErrorBoundary';
import SuccessionThemeProvider from '../components/Succession/SuccessionThemeProvider';
import client from '../lib/apolloClient';

// GraphQL query to get catastrophe form data
const GET_CATASTROPHE_DATA = gql`
  query GetCatastropheFormData {
    getCurrentUser {
      id
      catastrophe_form_datum {
        id
        user_id
        formData
        currentSection
        sectionCount
        completionPercentage
        status
        welcomeShown
        aiInsights {
          keyStrengths
          identifiedRisks
          actionRecommendations
          complianceStatus
        }
      }
    }
  }
`;

// Simple loading spinner component with succession theming
const SimpleLoadingSpinner = () => (
  <div className="flex justify-center items-center min-h-[200px] bg-succession-bg-secondary transition-colors duration-300">
    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-succession-primary"></div>
  </div>
);

const CatastropheGeneratorContainer = (props, railsContext) => {
  console.log('CatastropheGeneratorContainer - Props:', props);
  console.log('CatastropheGeneratorContainer - RailsContext:', railsContext);
  
  // Extract company data for theming (following same pattern as other succession containers)
  const companyData = props?.company || {
    id: railsContext?.company_id,
    name: railsContext?.company_name,
    host: railsContext?.company_host,
    primary_color: props?.primary_color,
    secondary_color: props?.secondary_color,
    neutral_color: props?.neutral_color,
    accent_color: props?.accent_color,
  };

  console.log('CatastropheGeneratorContainer - Company data for theming:', companyData);

  return (
    <ApolloProvider client={client}>
      <SuccessionThemeProvider 
        company={companyData}
        user={props?.current_user}
      >
        <ErrorBoundary>
          <Query query={GET_CATASTROPHE_DATA}>
            {({ loading, error, data }) => {
              if (loading) return <SimpleLoadingSpinner />;
              if (error) return (
                <div className="min-h-screen bg-succession-bg-secondary p-6">
                  <div className="max-w-2xl mx-auto bg-succession-bg-primary rounded-lg p-6 border border-succession-border">
                    <div className="text-succession-error text-center">
                      Error loading catastrophe data: {error.message}
                    </div>
                  </div>
                </div>
              );
              
              const catastropheData = data?.getCurrentUser?.catastrophe_form_datum || null;
              
              return (
                <CatastropheGenerator 
                  catastropheData={catastropheData}
                />
              );
            }}
          </Query>
        </ErrorBoundary>
      </SuccessionThemeProvider>
    </ApolloProvider>
  );
};

export default CatastropheGeneratorContainer; 